export enum RecommendationTopic {
  General = 'general',
  SubmissionForm = 'submissionForm',
  RegistrationForm = 'registrationForm',
}

export interface RecommendationDto {
  id: string;
  sanityCheckId: string;
  topic: RecommendationTopic;
  title: string;
  description: string;
  severity: 'info' | 'warning' | 'critical';
}

export interface SanityCheckDto {
  id: string;
  eventId: string;
  userId: string;
  processingTimeMs: number;
  creationDate: string;
  recommendations: RecommendationDto[];
}
